export default {
  main: {
    display: 'flex',
    alignItems: 'baseline',
    fontSize: '0.7em',
    marginTop: '1em',
  },
}
